import { Box, Grid } from '@mui/material';
import classNames from 'classnames';
import EmptyOrderFooter from '../EmptyOrderFooter';
import OrderActiveSubtitle from '../OrderActiveSubtitle';
import OrderBookDivider from '../OrderBookDivider';
import OrderBookHeader from '../OrderBookHeader';
import { useOrderBookStyles } from '../styles/OrderBookStyles';

const EmptyOrderBook = () => {
  const { classes } = useOrderBookStyles();

  return (
    <Grid container className={classes.orderBookContainer}>
      <Grid>
        <Grid container spacing={1}>
          <Grid className={classes.item}>
            <Box className={classes.horizontalPadding}>
              <OrderBookHeader />
            </Box>
          </Grid>
          <Grid>
            <Box className={classNames(classes.horizontalPadding, classes.subtitleBox)}>
              <OrderActiveSubtitle />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.item}>
        <OrderBookDivider />
      </Grid>
      <Grid className={classNames(classes.item, classes.marginBottom)}>
        <Box className={classes.horizontalPadding}>
          <EmptyOrderFooter />
        </Box>
      </Grid>
    </Grid>
  );
};

export default EmptyOrderBook;
